import { render, staticRenderFns } from "./DataInputTextarea.vue?vue&type=template&id=4c3e04fe&"
import script from "./DataInputTextarea.vue?vue&type=script&lang=js&"
export * from "./DataInputTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports